import { memo } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledModalActions,
    StyledModalContent,
    StyledModalTitle,
} from "app/pages/benchmark-tracker/components/Report/SubscriptionModal/styles";
import { generateAutomationName } from "app/pages/benchmark-tracker/helpers/helpers";
import { benchmarkTrackerTracking } from "app/pages/benchmark-tracker/services/tracking";
import { closeSubscriptionModal } from "app/pages/benchmark-tracker/store/actions/report";
import { unsubscribeFromDigestEffect } from "app/pages/benchmark-tracker/store/effects/menu";
import { selectSelectedBenchmark } from "app/pages/benchmark-tracker/store/selectors/entitySelectors";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type UnsubscribeContentSchema = {
    isViewerMode: boolean;
};

export const UnsubscribeContent = memo(({ isViewerMode }: UnsubscribeContentSchema) => {
    const dispatch = useDispatch();
    const selectedBenchmark = useSelector(selectSelectedBenchmark);
    const { name } = selectedBenchmark ?? {};
    const { key: benchmarkId } = proNavigator.getParams();
    const track = benchmarkTrackerTracking.report;

    const closeModal = () => {
        dispatch(closeSubscriptionModal());
        track.cancelSubscriptionModal(!isViewerMode);
    };

    const onUnsubscribe = () => {
        dispatch(unsubscribeFromDigestEffect(benchmarkId, name ?? ""));
        track.unsubscribeFromDigest(!isViewerMode);
    };

    return (
        <>
            <StyledModalTitle
                data-automation={generateAutomationName("report", ["subscription", "modal", "unsubscribe", "title"])}
            >
                {translate("bt.menu.unsubscribe")}
            </StyledModalTitle>

            <StyledModalContent
                data-automation={generateAutomationName("report", ["subscription", "modal", "unsubscribe", "text"])}
            >
                {translate("bt.subscription.unsubscribe.text")}
            </StyledModalContent>

            <StyledModalActions>
                <Button
                    type="flatDark"
                    onClick={closeModal}
                    dataAutomation={generateAutomationName("report", ["subscription", "modal", "cancel", "button"])}
                >
                    {translate("global.cancel")}
                </Button>
                <Button
                    type="warning"
                    onClick={onUnsubscribe}
                    dataAutomation={generateAutomationName("report", [
                        "subscription",
                        "modal",
                        "unsubscribe",
                        "button",
                    ])}
                >
                    {translate("bt.menu.unsubscribe")}
                </Button>
            </StyledModalActions>
        </>
    );
});

UnsubscribeContent.displayName = "UnsubscribeContent";
